<template>
  <div>
    <v-row>
     
      <v-col cols="12" class='ml-5'>
        <v-radio-group
          v-model="user.health.isGeneticTest"
          true-value="true"
          false-value="false">
          <v-radio
            label="Yes"
            :value="true"></v-radio>
          <v-radio
            label="No"
            :value="false"></v-radio>
        </v-radio-group>
      </v-col>
      <v-col  cols="10" class='ml-5' v-show='user.health.isGeneticTest'>
         <v-select
            v-model="user.health.GeneticTestType"
          :items="items"
          label="What type of genetic test did you have?"
        ></v-select>
      
      </v-col>
       <v-col  cols="10" class='ml-5' v-show='user.health.isGeneticTest'>
         <v-textarea
            v-model="user.health.GeneticTestResult"
          label="What were the results (if you know them)?"
        ></v-textarea>
      
      </v-col>
      <v-spacer></v-spacer>
    </v-row>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
export default {
    computed: {
    ...mapFields("patientQuestion", [
      "dataModel",
    ]),
    ...mapFields([
      "user"
    ])
  },
  data: () => ({
      items : ["Hereditary Cancer","Genetic Carrier Screening"," Direct-to-Consumer Testing (23andMe, Ancestry.com, etc)"]
    
  })
};
</script>
